export interface GasNetworkTariffModel {
    id?: number;
    name?: string;
    description?: string;
    cost?: number;
    min_rent_hours?: number;
    type?: GasNetworkTariffModel.TypeEnum;
    overpay_cost?: number;
    overpay_cost_2?: number;
    return_price_to_another_point?: number;
}
export namespace GasNetworkTariffModel {
    export type TypeEnum = 'daily' | 'fixed_hours';
    export const TypeEnum = {
        Daily: 'daily' as TypeEnum,
        FixedHours: 'fixed_hours' as TypeEnum
    };
}
